import { ActionEnum } from '@vendia/management-api-types'
import { useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { LinkItem, SideNavLinkItem } from 'src/components/navigation/side-nav-link-item'
import { useGetOrgDetails } from 'src/utils/hooks/use-get-org-details'
import useRolePermits from 'src/utils/hooks/use-role-permits'

export default function OrgNav() {
  const canListOrgUsers = useRolePermits({ action: ActionEnum.OrgListUsers })
  const getOrgDetails = useGetOrgDetails()
  const canListOrgUnis = Boolean(getOrgDetails?.data?.getOrganization?.unis?.length)
  const canListRoles = useRolePermits({ action: ActionEnum.RoleGet })
  const canListCredentialsPermission = useRolePermits({ action: ActionEnum.ApicredsGet })
  const location = useLocation()

  // Capture the "from" path on first render — passed via navigation state from the Admin link.
  // Uses a ref so clicking around /org pages doesn't overwrite it.
  const backPathRef = useRef<string>((location.state as any)?.from || '/')

  const links: LinkItem[] = [
    {
      label: 'Back',
      path: backPathRef.current,
      iconName: 'lucide-arrow-left',
      isBack: true,
    },
  ]

  links.push({
    label: 'Org overview',
    path: 'overview',
  })

  if (canListOrgUsers) {
    links.push({
      label: 'Members',
      path: 'members',
    })
  }

  if (canListRoles) {
    links.push({
      label: 'Roles',
      path: 'roles',
    })
  }

  if (canListOrgUnis) {
    links.push({
      label: 'Projects',
      path: 'projects',
    })
  }

  if (canListCredentialsPermission) {
    links.push({
      label: 'API Credentials',
      path: 'api-credentials',
    })
  }

  const linkListItems = links?.map((link, index) => {
    const basePath = '/org/'
    const path = link.path?.startsWith('/') ? link.path : `${basePath}${link.path}`
    // Normalize trailing slash and compare to find active path
    const currentPath = location.pathname.replace(/\/+$/, '')
    const currentLinkPath = path.replace(/\/+$/, '')
    const isActive =
      currentPath === '' || currentLinkPath === ''
        ? currentPath === currentLinkPath
        : currentPath.includes(currentLinkPath)
    link.isActive = isActive
    link.path = path

    return <SideNavLinkItem key={`${path}-${index}`} linkItem={link} />
  })

  return (
    <div className={'max-h-[calc(100vh-76px)] w-56 overflow-y-auto border-t border-slate-200 p-4 pt-8'}>
      {linkListItems}
    </div>
  )
}
